import CoreLayout from '../../layouts/core-layout';
import { useTranslation } from "react-i18next";
import { useAuth } from 'react-oidc-context';
import i18n from "../../i18n";

export const ErrorLoginState = () => {
  const { t } = useTranslation(); // Multi Language
  const auth = useAuth()
  return (
    <CoreLayout template="auth">
      <div className="row mt-10 text-white d-flex flex-column align-items-center justify-content-center" style={{ height: '75vh' }}>
        <div className="text-center" style={{ fontSize: "3rem" }}><b>{t('errors:errorLoginState.loginStatus')}</b></div>
        <div className="text-center mt-5" style={{ fontSize: "1.5rem" }}>{t('errors:errorLoginState.message')}</div>
        <div className="text-center my-10 d-flex flex-column flex-lg-row align-items-center justify-content-center gap-4">

          <button onClick={() => { window.location.href = '/dashboard' }} className="btn btn-primary px-4 fs-4">{t('errors:errorLoginState.refresh')}</button>

          {auth?.isAuthenticated ? <button onClick={() => {
            auth.signoutRedirect({
              extraQueryParams: {
                kc_locale: i18n.language
              }
            })

          }} className="btn btn-primary px-2 fs-5">{t('errors:errorLoginState.logout')}</button> : false}
        </div>
      </div>
    </CoreLayout>)
}
